<script lang="ts">
	import { goto } from '$app/navigation';
	import ForgotPassword from '$lib/components/Auth/ForgotPassword/ForgotPassword.svelte';

	function handleLogIn() {
		goto('/');
	}
</script>

<div class="vert-center">
	<div class="flex-1 flex">
		<div class="flex-1 w-1/2 bg-lemon bg-svg bg-gradient-signup hidden md:block" />
		<ForgotPassword
			additionalClass="flex-1 w-1/2 vert-center mx-auto px-4 sm:px-8"
			on:success={handleLogIn}
		/>
	</div>
</div>
